import React from 'react'

import { useDocumentCardContext } from '@frame/ui-components/document-card/context'
import { Button } from '@frame/ui-primitives/button'

import { FileUploadState } from '@documents/types'
import { TwCircleCancel } from '@frame/images/icons/tw-circle-cancel'
import { UploadFileError } from '@frame/lib/api/tasks/types'
import { DocumentCardDataAttribute } from '@frame/types'

import { Divider } from '../divider'
import { FailureMessage } from '../failure-message'
import { Header } from '../header'

type Props = {
  fileName: string
  tempId: string
  fileId?: string
  onRetry?: () => void
  onDelete?: () => void
  isRetryable: boolean
  error?: UploadFileError['file']
}

export function Failed({ fileName, tempId, fileId, onRetry, onDelete, isRetryable, error }: Props) {
  const { setSelectedFileToRemove } = useDocumentCardContext()
  return (
    <>
      <Header
        Icon={TwCircleCancel}
        name={fileName}
        onDelete={onDelete}
        setSelectedFileToRemove={() =>
          setSelectedFileToRemove({
            tempId: tempId,
            fileId: fileId,
            fileName: fileName,
            state: FileUploadState.FAILED,
          })
        }
      />
      <Divider />
      {error?.map((e) => (
        <FailureMessage key={e}>{e}</FailureMessage>
      ))}
      {isRetryable && onRetry && (
        <Button data-cy={DocumentCardDataAttribute.RETRY_UPLOAD_BUTTON} onClick={onRetry}>
          Retry upload
        </Button>
      )}
    </>
  )
}
